import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ThemeProvider } from 'styled-components';
import { Box as ReflexboxBox } from 'reflexbox/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";

function Box(props) {
  return _jsx(ThemeProvider, {
    theme: {
      breakpoints: ['64em', '80em', '90em', '120em']
    },
    children: _jsx(ReflexboxBox, _objectSpread(_objectSpread({
      id: props.id
    }, props), {}, {
      children: props.children
    }))
  });
}

Box.defaultProps = {};
Box.displayName = 'Box';
export default Box;